

// src/pages/LeavePage.jsx
import React, { useState } from 'react';
import ApplyLeave from './Leave/ApplyLeave';
import LeaveDetails from './Leave/LeaveDetails';

const LeavePage = () => {
  const [activeTab, setActiveTab] = useState('apply');

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="bg-sky-400 text-white text-center p-4 font-bold text-lg">
        Leave
      </div>

      {/* Tabs */}
      <div className="flex">
        <button
          className={`flex-1 py-2 font-semibold ${activeTab === 'apply' ? 'bg-orange-400 text-white' : 'bg-orange-300'}`}
          onClick={() => setActiveTab('apply')}
        >
          Leave Apply
        </button>
        <button
          className={`flex-1 py-2 font-semibold ${activeTab === 'details' ? 'bg-orange-400 text-white' : 'bg-orange-300'}`}
          onClick={() => setActiveTab('details')}
        >
          Leave Details
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 bg-slate-700 text-white px-4 pb-4">
        {activeTab === 'apply' ? <ApplyLeave /> : <LeaveDetails />}
      </div>
    </div>
  );
};

export default LeavePage;
